import { About } from '../pages/About'
import { Home } from '../pages/Home'
import { Login } from '../pages/Login'
import { ProductList } from '../pages/ProductList'
import { ThreeDProducts } from '../pages/ThreeDProducts'
import { ForgotPassword } from '../pages/ForgotPassword'
import { AddMember } from '../pages/AddMember'
import { PasswordRenew } from '../pages/PasswordRenew'
import { MyAccount } from '../pages/MyAccount'
import Activation from '../pages/Activation'
import { ProductGroup } from '../pages/ProductGroup'
import { DownloadedProducts } from '../pages/DownloadedProducts'
import { ProductDetails } from '../pages/ProductDetails'
import { CodeResolver } from '../pages/CodeResolver'
import { IconHome, IconFiles, Icon3dCubeSphere, IconUser, IconDownload, IconBinary } from '@tabler/icons-react';

export const nav = [
    { path: "/", name: 'menuAnaSayfa', element: <Home />, isMenu: true, isPrivate: true, icon: <IconHome size={20} /> },
    { path: "/login", name: 'menuGiris', element: <Login />, isMenu: false, isPrivate: false },
    // { path: "/about", name: 'menuHakkimizda', element: <About />, isMenu: true, isPrivate: false },    
    { path: "/productlist", name: 'menuUrunDosyalari', element: <ProductList />, isMenu: true, isPrivate: true, icon: <IconFiles size={20} /> },
    { path: "/ThreeDProducts", name: 'menu3DUrunler', element: <ThreeDProducts />, isMenu: true, isPrivate: true, icon: <Icon3dCubeSphere size={20} /> },
    { path: "/coderesolver", name: 'menuTekerKoduCozumleyici', element: <CodeResolver />, isMenu: true, isPrivate: true, icon: <IconBinary size={20} /> },
    { path: "/myaccount", name: 'menuBilgilerim', element: <MyAccount />, isMenu: true, isPrivate: true, icon: <IconUser size={20} /> },
    { path: "/downloaded", name: 'menuIndirdigimUrunler', element: <DownloadedProducts />, isMenu: true, isPrivate: true, icon: <IconDownload size={20} /> },
    { path: "/addmember", name: 'menuUyeOl', element: <AddMember />, isMenu: false, isPrivate: false },
    { path: "/forgotpassword", name: 'menuSifremiUnuttum', element: <ForgotPassword />, isMenu: false, isPrivate: false },
    { path: "/passwordrenew", name: 'menuSifremiYenile', element: <PasswordRenew />, isMenu: false, isPrivate: false },
    { path: "/activation", name: 'menuAktivasyon', element: <Activation />, isMenu: false, isPrivate: false },
    { path: "/productdetails/:id", name: 'menuUrunDetay', element: <ProductDetails />, isMenu: false, isPrivate: true }
]